<template>
  <div class="d-flex mt-4 mb-5">
    <div class="d-flex flex-column mr-1 mt-2">
      <strong>{{ $t('global.conditions') }}:</strong>
    </div>
    <div class="d-flex flex-column ml-4">
      <button class="btn btn-medium btn-border" @click="addCondition()">
        <plus-circle-icon></plus-circle-icon>
        <span>{{$t('feeds.add_condition')}} ({{ conditions.length }})</span>
      </button>
      <transition-group name="fade" mode="out-in" tag="div">
        <div v-for="(condition, index) in conditions" v-bind:key="index+1" class="d-flex align-items-center mt-4">
          <p v-if="index > 0" class="mb-0 mr-3">{{ $t('conditions.and_if') }}</p>
          <p v-else class="mb-0 mr-4 pr-1">{{ $t('conditions.if') }}</p>
          <multiselect
            @select="onConditionSourceVariableSelect($event, condition)"
            class="condition-source-variable-multiselect"
            label="labelBracket"
            v-model="condition.selectedSourceVariable"
            :allow-empty="false"
            :deselect-label="''"
            :options="availableSourceVariables"
            :placeholder="$t('feeds.choose_variable')"
            :searchable="true"
            :select-label="''"
            :selected-label="''"
            :value="condition.columnName">
            <span slot="noResult">{{ $t('global.multiselect_search_not_found') }}</span>
          </multiselect>
          <multiselect
            @select="onConditionTypeSelect($event, condition)"
            class="condition-type-multiselect mx-4"
            label="label"
            v-model="condition.selectedConditionType"
            :allow-empty="false"
            :deselect-label="''"
            :options="conditionTypes"
            :placeholder="$t('feeds.rule_condition_type')"
            :searchable="false"
            :select-label="''"
            :selected-label="''">
          </multiselect>
          <div v-show="condition.conditionType !== 'empty' && condition.conditionType !== 'not empty'" class="condition-value-container">
            <div class="d-flex mr-4" id="conditionStringInputContainer">
              <input v-model="condition.conditionString" id="conditionStringInput" class="form-control" name="conditionString" type="text">
              <div v-if="condition.conditionType === 'in list'" class="d-flex align-items-center ml-3">
                <img class="tooltip-icon icon-small" id="tooltip-condition-in-list" v-bind:src="'/app/images/icons/info.svg'"/>
                <b-popover target="tooltip-condition-in-list" variant="secondary" triggers="hover" placement="bottomleft">
                  <div v-html="$t('conditions.in_list_description')"></div>
                </b-popover>
              </div>
            </div>
            <p v-if="!condition.isValid" class="text-danger pr-4">{{ condition.errorMessage }}</p>
          </div>
          <button class="btn btn-tiny btn-gray-dark" @click="deleteCondition(index)"><x-icon></x-icon></button>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { PlusCircleIcon, XIcon } from 'vue-feather-icons'
import Multiselect from 'vue-multiselect'
import feeds from '@/mixins/feeds'

export default {
  name: 'Conditions',

  data () {
    return {
      conditions: [],
      isValid: true
    }
  },

  props: {
    availableSourceVariables: { required: true, type: Array },
    savedConditions: { required: false, type: Array }
  },

  mixins: [feeds],

  created () {
    if (this.savedConditions !== undefined) this.conditions = this.savedConditions
  },

  methods: {
    addCondition () {
      this.conditions.push({ columnName: '', conditionString: '', conditionType: '' })
    },

    resetCondition (condition) {
      condition.columnName = ''
      condition.conditionType = ''
      condition.conditionString = ''
      condition.selectedSourceVariable = {}
      condition.selectedConditionType = {}
    },

    deleteCondition (index) {
      this.conditions.splice(index, 1)
    },

    onConditionSourceVariableSelect (sourceVariable, condition) {
      condition.columnName = sourceVariable.labelDash
      condition.conditionType = ''
      condition.conditionString = ''
      condition.selectedSourceVariable = sourceVariable
      condition.selectedConditionType = ''
    },

    onConditionTypeSelect (conditionType, condition) {
      condition.conditionType = conditionType.value
      condition.conditionString = ''
      condition.selectedConditionType = conditionType
    },

    validateRegex (string) {
      let isValid = true
      try {
        const newRegExp = new RegExp(string)
        console.log(newRegExp)
      } catch (e) {
        isValid = false
      }
      return isValid
    },

    validateNumber (conditionString) {
      if (isNaN(conditionString)) return false
      else return true
    }
  },

  watch: {
    conditions: {
      handler (newConditions) {
        this.isValid = true
        newConditions.forEach((condition) => {
          condition.errorMessage = ''
          if (condition.columnName === '') {
            this.isValid = false
          } else if (condition.selectedConditionType === '') {
            this.isValid = false
          } else {
            if ((condition.selectedConditionType.value === 'lower then') || (condition.selectedConditionType.value === 'greater then')) {
              const isNumberValid = this.validateNumber(condition.conditionString)
              if ((!isNumberValid) || (condition.conditionString === '')) {
                condition.errorMessage = this.$t('feeds.rule_must_be_numeric_value')
                this.isValid = false
              }
            } else if (condition.selectedConditionType.value === 'regex') {
              const isRegexValid = this.validateRegex(condition.conditionString)
              if (!isRegexValid) {
                this.isValid = false
                condition.errorMessage = this.$t('feeds.rule_invalid_regex')
              }
            } else if ((condition.selectedConditionType.value !== 'empty') && (condition.selectedConditionType.value !== 'not empty')) {
              if (condition.conditionString === '') {
                this.isValid = false
              }
            }
          }
        })
        this.$emit('onConditionsValidate', this.isValid)
        this.$emit('onConditionsChange', this.conditions)
      },
      deep: true
    }
  },

  components: { Multiselect, PlusCircleIcon, XIcon }
}
</script>
